export class SaveCWSCategoryConvListModel {

  // カテゴリ区分
  public categoryDiv: string = <string>'';
  // 変換区分
  public convDiv: string = <string>'';
  // カテゴリ
  public categoryCode: string = <string>'';
  // 部門
  public classCode: string = <string>'';
  // 大分類
  public largeClassCode: string = <string>'';
  // 中分類
  public middleClassCode: string = <string>'';
  // 小分類
  public smallClassCode: string = <string>'';
  // マーク
  public markCode: string = <string>'';
  // 価格パターン
  public pricePattern: string = <string>'';
  // 媒体
  public mediumType: string = <string>'';
  // 特集
  public featureCode: string = <string>'';
  // ページ
  public pageNum: string = <string>'';
  // プロモーション区分
  public promotionDiv: string = <string>'';
  // プロモーション情報
  public promotionInfo: string = <string>'';
  // 催事
  public exhibitionDiv: string = <string>'';
  // タグ１
  public tag1: string = <string>'';
  // タグ２
  public tag2: string = <string>'';
}
